<template>
  <v-card class="mb-4 px-1" v-if="item.file">
    <v-layout v-bind="layout" style="margin-top: 0px">
      <v-flex xs2 mx-3 mt-2>
        <a :href="item.file.files.preview" target="_blank" v-if="item.file.files.preview">
          <img class="elevation-3 preview-image" :src="item.file.thumbs.medium" alt="">
        </a>
        <div v-else class="elevation-3 preview-image center-align red" style="height:180px;">
          <br><br>
          ERROR:<br>
          No Files Found
        </div>
      </v-flex>
      <v-flex xs7 mt-2 mb-0 pb-0>
        <item-description :item='item' :largeTitle="true"/>
        <br>
        <template v-if="!ordered">
          <span style="color:red">THIS ITEM HAS NOT BEEN ORDERED</span>
          <span class="btn-group ml-3">
            <addToStore :item="item" v-if="hasStore()">
              <v-tooltip top>
                <v-btn icon slot="activator">
                  <v-icon>mdi-store</v-icon>
                </v-btn>
                <span>Add Item To Store</span>
              </v-tooltip>
            </addToStore>
            <v-tooltip top>
              <v-btn icon slot="activator" :to="'/items/' + item.id">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <span>Edit Item</span>
            </v-tooltip>
            <v-tooltip top>
              <v-btn icon slot="activator" @click="deleteItem()">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
              <span>Delete Item</span>
            </v-tooltip>
          </span>
        </template>
        <p v-if="ordered">
          LAST ORDERED: {{created_on | moment('MM/DD/YYYY hh:mm A [PT]z')}},
          {{item.quantity}} Qty @ {{item.unit_price | currency}} Ea,
          Order #
          <a :href="'/orders/' + item.order_id" target='_blank'>{{item.site_code}}{{item.order_id}}</a>
        </p>
      </v-flex>
      <v-flex xs3 class="right-align">
        <div class="center-align">
          <fancy-price class="mt-1 pb-4" :price="unitPrice">{{nextPrice}}</fancy-price>
          <div>
            <span class="cart-control center-align">
              <v-icon @mousedown="changeQuantity(-1)">mdi-minus</v-icon>
              <input class="quantity" name="quantity" size=4 maxlength=3 v-model="quantity" placeholder="QTY" mast="###">
              <v-icon @mousedown="changeQuantity(1)">mdi-plus</v-icon>
            </span>
          </div>
          <v-btn color="primary" @click="updateCart()">Add To Cart</v-btn>
        </div>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<style lang="sass">
.item-status
  margin-left: 57px
</style>

<script>
  import Events from '@/api/events'
  import DetailModal from '../widgets/detail-modal'
  import FancyPrice from '../widgets/fancy-price'
  import ItemDescription from '../widgets/item-description'
  import addToStore from './add-to-store'

  export default {
    components: {
      detailModal: DetailModal,
      fancyPrice: FancyPrice,
      addToStore: addToStore,
      itemDescription: ItemDescription
    },

    data () {
      return {
        quantity: 1
      }
    },

    props: {
      item: { type: Object, required: true },
      index: { type: Number, required: true },
      itemType: { type: String, required: true }
    },

    watch: {
      'quantity': function () {
        if (parseInt(this.quantity) >= 500) {
          this.quantity = 1
          Events.$emit('error', 'Please Contact Gung-Ho for pricing on 500+ quantities')
        }
      }
    },

    computed: {
      layout () {
        const layout = {}
        if (this.$vuetify.breakpoint.smAndDown) layout.column = true
        return layout
      },

      finished () {
        if (this.item.finished_at) return true
        else return false
      },

      ordered () {
        if (this.itemType === 'ordered') return true
        else return false
      },

      cart: {
        get () {
          return this.$store.state.cart
        },
        set (value) {
          this.$store.commit('saveCart', value)
        }
      },

      cartItem () {
        if (!this.cart || this.cart.cart_items.length < 1) return { quantity: 1 }
        for (var item of this.cart.cart_items) {
          if (this.finished && item.order_item_id === this.item.id) return item
          if (!this.finished && item.project_id === this.item.id) return item
          return { quantity: 1 }
        }
      },

      nextPrice () {
        if (this.quantity < 5) {
          return '$' + this.item.unit_prices[5].toFixed(2) + ' for 5–99 Qty'
        } else if (this.quantity < 100) {
          return '$' + this.item.unit_prices[100].toFixed(2) + ' for 100-249 Qty'
        } else if (this.quantity < 250) {
          return '$' + this.item.unit_prices[250].toFixed(2) + ' for 250-499 Qty'
        } else if (this.quantity < 500) {
          return 'Please Contact Gung-Ho for pricing on 500+ quantities'
        } else {
          return ''
        }
      },

      unitPrice () {
        if (this.quantity >= 250) return this.item.unit_prices[250]
        else if (this.quantity >= 100) return this.item.unit_prices[100]
        else if (this.quantity >= 5) return this.item.unit_prices[5]
        else return this.item.unit_prices[1]
      },

      created_on () {
        return this.item.created_at.split(' ')[0]
      }
    },

    methods: {
      changeQuantity (by) {
        this.quantity = parseInt(this.quantity)
        if ((this.quantity + by) > -1 && (this.quantity + by) < 500) {
          this.quantity += by
        }
      },

      deleteItem () {
        this.$confirm(`Delete item ${this.item.name}?`).then(confirmed => {
          if (!confirmed) return
          Events.$emit('deleteItem', this.item, this.index)
        })
      },

      updateCart () {
        if (this.cartItem) {
          if (this.ordered) {
            console.log('Added Order Item')
            this.addOrderItem()
          } else {
            console.log('Added Project Item')
            this.addProjectItem()
          }
        } else {
          this.updateCartItem()
        }
      },

      addOrderItem () {
        this.$store.dispatch('addCartItem', {
          'order_item_id': this.item.id,
          'quantity': this.quantity
        })
      },

      addProjectItem () {
        this.$store.dispatch('addCartItem', {
          'project_id': this.item.id,
          'quantity': this.quantity
        })
      },

      updateCartItem () {
        this.$store.dispatch('updateCartItem', {
          id: this.cartItem.id,
          quantity: this.quantity
        })
      },

      hasStore () {
        if (!this.$store.state.user.features) return false
        return this.$store.getters.features.includes('store')
      }
    },

    beforeMount () {
      this.quantity = this.cartItem.quantity
    }
  }
</script>



// WEBPACK FOOTER //
// card.vue?ff06fb38